import { DolphinReservationModelBase } from "./DolphinReservationModel.base"


/* A graphql query fragment builders for DolphinReservationModel */
export { selectFromDolphinReservation, dolphinReservationModelPrimitives, DolphinReservationModelSelector } from "./DolphinReservationModel.base"

/**
 * DolphinReservationModel
 *
 * A Dolphin reservation
 */
export const DolphinReservationModel = DolphinReservationModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
